module.exports = __webpack_public_path__ + "static/test2-bd31874411fe0314c0bd2711d073463c.png";